export const blockIconsCommunicationContactMailNew = (
	<span className='material-symbols-outlined'>contact_mail</span>
);
